import script from "./TextContent.vue?vue&type=script&setup=true&lang=js"
export * from "./TextContent.vue?vue&type=script&setup=true&lang=js"

import "./TextContent.vue?vue&type=style&index=0&id=3d3f4b4c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d3f4b4c"]])

export default __exports__